import React, { useEffect } from "react";
import getCommonStaticProps from "@xt/ssg";
import LayoutXt from "components/Layout/xt";
import LayoutAuth from "components/Layout/Auth";
import Register from "components/Pages/Register";
import { redirectBackUrl } from "utils/method";
import { useRouter } from "next/router";
import Seo from "components/Seo";
import useIsDesktop from "@/hooks/useIsDesktop";

export default function PageRegister({ locale, tdk, resolvedUrl }) {
  const router = useRouter();
  const { isDesktop, isReady } = useIsDesktop();
  const isSpikexPc = isReady && isDesktop;

  const onAuthError = () => {
    redirectBackUrl(router);
  };

  // 添加数据统计
  useEffect(() => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML =
      "(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];var s='script';r=t.createElement(s);r.async=!0;r.src=n;var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u);})(window,document,'https://sc-static.net/scevent.min.js');snaptr('init', 'b0724586-a27d-4ef5-a09c-ef349ae6264e', {'user_email': '__INSERT_USER_EMAIL__'});snaptr('track', 'PAGE_VIEW')";
    document.getElementsByTagName("head")[0].appendChild(script);
  }, []);

  return (
    <>
      <Seo tdk={tdk} resolvedUrl={resolvedUrl} locale={locale} />

      <LayoutXt mobileNav="logoLang" isShowFoot={isSpikexPc} useSiteFooter={isSpikexPc}>
        <LayoutAuth needLogin={false} onAuthError={onAuthError}>
          <Register />
        </LayoutAuth>
      </LayoutXt>
    </>
  );
}

export const getStaticProps = (context) => getCommonStaticProps(context, "/accounts/register", { zE_show: true });
